module.exports = __webpack_public_path__ + "img/table-widget-illustration-1.8c4b19bb.png";